export class ClientPageRenderer {};
